import script from "./ApprovalLabel.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApprovalLabel.vue?vue&type=script&setup=true&lang=ts"

import "./ApprovalLabel.vue?vue&type=style&index=0&id=bf72d808&scoped=true&lang=css"

import exportComponent from "C:\\atto\\atto-chempanda\\chempanda\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf72d808"]])

export default __exports__